import moment from "moment";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DATE_FORMAT } from "../../../../../../server/types";
import usePageLogUpdatedPriceContext from "../../Provider/hooks/usePageLogUpdatedPriceContext";
import { TContext } from "../../Provider/types";

const useButtonSearch = () => {
  const { filter, isLoading, page } = usePageLogUpdatedPriceContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  return {
    isDisabled: isLoading.value,
    handlerClick: () => {
      //@ts-ignore
      (Array.from(searchParams.keys()) as string[])
        .filter((key) => key.indexOf("filter.") === 0)
        .forEach((key) => {
          searchParams.delete(key);
        });
      (
        Object.keys(filter.value) as (keyof TContext["filter"]["value"])[]
      ).forEach((field) => {
        const value = filter.value[field] ?? undefined;
        if (value === undefined) {
          return;
        }
        if (value instanceof Date) {
          searchParams.set(
            "filter." + field,
            moment(value).format(DATE_FORMAT)
          );
        } else if (moment.isMoment(value)) {
          searchParams.set("filter." + field, value.format(DATE_FORMAT));
        } else {
          searchParams.set("filter." + field, value.toString());
        }
        navigate("/logUpdated/price?" + searchParams.toString());
        page.update(0);
      });
    },
  };
};

export default useButtonSearch;
